import { useContext, useEffect, useState } from "react";
import styles from "./Checkbox.module.scss";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ApplicationContext } from "../../context/ApplicationContext";

const Checkbox = ({
  text,
  error,
  disabled = false,
  marketingFlag = false,
  checked = false,
  name,
  myinfo = false,
  inputProps,
  confirmButton,
  required,
  errorCheck,
}) => {
  const [showError, setShowError] = useState(false);
  const { setMarketing } = useContext(ApplicationContext);
  const { marketing } = useContext(ApplicationContext);
  const [actualDisabled, setActualDisabled] = useState();
  const { myInfo } = useContext(ApplicationContext);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    if (marketingFlag && checked) {
      setMarketing(false);
    }
    setActualDisabled(true);
  }, [disabled]);

  const clickHandler = (e) => {
    if (error) {
      setShowError(!showError);
    }
    if (marketingFlag) {
      setMarketing(!marketing);
    }
    if (myinfo) {
      myInfo.change = true;
      if (name == "privacy1") {
        myInfo.profiling_agreement = e.target.checked;
      } else if (name == "privacy2") {
        myInfo.marketing_agreement = e.target.checked;
      } else if (name == "outlets") {
        myInfo.preferred_location_group = e.target.checked;
      }
    }
    if (confirmButton) {
      setShowButton(!showButton);
    }
  };

  return (
    <div>
      <label
        className={styles.Checkbox}
        style={{
          color: disabled ? "#a9a9a9" : null,
          marginBottom: error && "2.375rem",
        }}
      >
        {actualDisabled && (
          <input
            disabled={disabled ? true : false}
            type="checkbox"
            name={name}
            onClick={(e) => clickHandler(e)}
            defaultChecked={checked ? true : false}
            checked={disabled ? false : null}
            {...inputProps}
          />
        )}
        <span
          className={styles.box}
          style={{ borderColor: disabled ? "#a9a9a9" : null }}
        ></span>
        <div dangerouslySetInnerHTML={{ __html: text }}></div>
      </label>

      {error && (
        <div
          className={styles.error}
          style={{ display: showError ? null : "none" }}
          dangerouslySetInnerHTML={{ __html: error }}
        ></div>
      )}

      {errorCheck && required && (
        <div className={styles.required}>
          <FontAwesomeIcon icon={faExclamationTriangle} />
          &nbsp;
          {required}
        </div>
      )}

      {/* bottone di conferma commentato */}
      {showButton && (
        <div className={styles.buttonContainer}>
          <button>{confirmButton}</button>
        </div>
      )}
    </div>
  );
};

export default Checkbox;
